import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import type {
  CardOrder,
  CardOrderCreatePayload,
  CardOrderListParams,
  CardOrderListResponse,
  CardOrderOptions,
} from "./card-orders.interface";

@Injectable({ providedIn: "root" })
export class CardOrdersService {
  constructor(private readonly http: HttpClient) {}

  listOrders(params: CardOrderListParams): Observable<CardOrderListResponse> {
    const httpParams: Record<string, string> = {
      page: String(params.page),
      limit: String(params.limit),
    };
    if (params.phrase?.trim()) {
      httpParams.phrase = params.phrase.trim();
    }
    return this.http.get<CardOrderListResponse>("/print-cards/orders", {
      params: httpParams,
    });
  }

  getOrder(orderId: string): Observable<CardOrder> {
    return this.http.get<CardOrder>(
      `/print-cards/orders/${encodeURIComponent(orderId)}`,
    );
  }

  getOrderOptions(): Observable<CardOrderOptions> {
    return this.http.get<CardOrderOptions>("/print-cards/orders/options");
  }

  createOrder(payload: CardOrderCreatePayload): Observable<CardOrder> {
    return this.http.post<CardOrder>("/print-cards/orders", payload);
  }

  cancelOrder(orderId: string): Observable<CardOrder> {
    return this.http.post<CardOrder>(
      `/print-cards/orders/${encodeURIComponent(orderId)}/cancel`,
      {},
    );
  }

  approveOrder(orderId: string): Observable<CardOrder> {
    return this.http.post<CardOrder>(
      `/print-cards/orders/${encodeURIComponent(orderId)}/approve`,
      {},
    );
  }
}
